module.exports = __webpack_public_path__ + "img/option-card-left-modal-icon.8f1adc65.svg";